/** Persistent profile photo blobs (Cache Storage). Revision in the storage key busts stale entries. */

export const PROFILE_PICTURE_BROWSER_CACHE = 'patient-profile-pictures-v1';

export function profilePictureBrowserCacheUrl(storageKey) {
  return `/__profile-picture-cache__/${encodeURIComponent(storageKey)}`;
}

export async function readProfilePictureBrowserBlob(storageKey) {
  if (typeof caches === 'undefined') return null;
  try {
    const cache = await caches.open(PROFILE_PICTURE_BROWSER_CACHE);
    const response = await cache.match(profilePictureBrowserCacheUrl(storageKey));
    if (!response?.ok) return null;
    return response.blob();
  } catch {
    return null;
  }
}

export async function writeProfilePictureBrowserBlob(storageKey, blob, contentType = 'image/webp') {
  if (typeof caches === 'undefined' || !blob) return;
  try {
    const cache = await caches.open(PROFILE_PICTURE_BROWSER_CACHE);
    await cache.put(
      profilePictureBrowserCacheUrl(storageKey),
      new Response(blob, {
        headers: { 'Content-Type': contentType || 'image/webp' },
      }),
    );
  } catch {
    // Quota, private mode, or unsupported — network + in-memory cache still work.
  }
}

/** @visibleForTesting */
export async function clearProfilePictureBrowserCache() {
  if (typeof caches === 'undefined') return;
  await caches.delete(PROFILE_PICTURE_BROWSER_CACHE);
}
